import { logo, smarrawdownIcon } from "../../assets/images/icons";
import { profileImage } from "../../assets/images/images";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../API";
import { resolveImageUrl } from "../../constants";
import "./navbar.css";
import { useTranslation } from 'react-i18next';
import {
  FaUser, FaCalendarAlt, FaTicketAlt, FaHeadset, FaSignOutAlt,
  FaHome, FaMapMarkedAlt, FaPassport, FaHotel, FaPlaneDeparture, FaSignInAlt
} from 'react-icons/fa';

export default function Navbar({ page }) {
  const { t, i18n } = useTranslation();
  const changeLanguage = (lng) => {
    if (i18n.language === lng) return;
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
    window.location.reload();
  };
  const isFr = i18n.language === 'fr';
  const isAr = i18n.language === 'ar';
  const navigate = useNavigate();
  const [options, setOptions] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState("John Doe");
  const [userData, setUserData] = useState(null);
  const profileimgRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem("protoken");
    const storedUsername = localStorage.getItem("fullname");
    const storedUserImage = localStorage.getItem("profileImage");

    if (token) {
      setIsLoggedIn(true);
      if (storedUsername) {
        setUsername(storedUsername);
      }
      if (storedUserImage) {
        setUserData({ ...userData, image: storedUserImage });
      }
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const handleProfileImgClick = () => {
    profileimgRef.current.click(); // Trigger file input click when user clicks on the image
  };

  useEffect(() => {
    const handleProfileImgChange = async () => {
      const token = localStorage.getItem("protoken");
      const userId = localStorage.getItem("userId");

      try {
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };

        // Send the image to the server to update the profile image
        const response = await API.get(`/users/${userId}`, config);

        // Update the user data with the new image URL
        setUserData((prevData) => ({
          ...prevData,
          image: response.data.image,
        }));

        // Optionally store the updated image URL in localStorage
        localStorage.setItem("profileImage", response.data.imageurl);
      } catch (error) {
        console.error("Error updating profile image:", error);
      }
    };

    handleProfileImgChange();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("protoken");
    localStorage.removeItem("fullname");
    localStorage.removeItem("email");
    localStorage.removeItem("userId");
    localStorage.removeItem("setupTime");
    localStorage.removeItem("profileImage");
    setIsLoggedIn(false);
    window.location.reload();
  };

  const [menuOpen, setMenuOpen] = useState(false);
  const updateMenu = () => setMenuOpen((v) => !v);
  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="Navbar">
      <div className="nav">
        {isLoggedIn ? (
          <div
            className="profile"
            onClick={() => setOptions((state) => !state)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                setOptions((state) => !state);
              }
            }}
          >
            <img
              className="nav_profileimg cover3"
              src={userData && userData.image ? resolveImageUrl(userData.image) : profileImage}
              alt=""
            />
            <p className="name">{username}</p>
            <img
              className={`${options ? "open" : "closed"}`}
              src={smarrawdownIcon}
              alt="show options"
            />
            <div
              className={`dropdown-container ${options ? "open" : "closed"}`}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="dropdown-content">
                <div className="dropdown-el" onClick={() => { setOptions(false); navigate("/profile"); }}>
                  <FaUser className="dropdown-icon" />
                  <p>{t('navbar.profile')}</p>
                </div>
                <div className="dropdown-el" onClick={() => { setOptions(false); navigate("/profile?tab=2"); }}>
                  <FaCalendarAlt className="dropdown-icon" />
                  <p>{t('navbar.my_reservations')}</p>
                </div>
                <div className="dropdown-el" onClick={() => { setOptions(false); navigate("/profile?tab=3"); }}>
                  <FaTicketAlt className="dropdown-icon" />
                  <p>{t('navbar.my_tickets')}</p>
                </div>
                <div className="dropdown-el" onClick={() => { setOptions(false); navigate("/profile?tab=4"); }}>
                  <FaHeadset className="dropdown-icon" />
                  <p>{t('navbar.help_support')}</p>
                </div>
                <div className="dropdown-divider"></div>
                <div className="dropdown-el logout" onClick={handleLogout}>
                  <FaSignOutAlt className="dropdown-icon" />
                  <p>{t('navbar.logout')}</p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <button onClick={() => { window.location.href = '/login'; }}>
            {t('navbar.login')} {/* Translated text */}
          </button>
        )}
        <div className="elements">
          <div
            className={page === "visit-algeria" ? "el selected" : "el"}
            onClick={() => { window.location.href = "/visit-algeria"; }}
          >
            <p>🇩🇿 {t('navbar.visit_algeria')}</p>
          </div>
          <div
            className={page === "voyage" ? "el selected" : "el"}
            onClick={() => { window.location.href = "/voyage"; }}
          >
            <p>{t('navbar.organizedTrip')}</p>
          </div>
          <div
            className={page === "hotels" ? "el selected" : "el"}
            onClick={() => { window.location.href = "/hotels"; }}
          >
            <p>{t('navbar.hotels')}</p>
          </div>
          <div
            className={page === "visa" ? "el selected" : "el"}
            onClick={() => { window.location.href = "/visa"; }}
          >
            <p>{t('navbar.visa')}</p>
          </div>
          <div
            className={page === "accueil" ? "el selected" : "el"}
            onClick={() => { window.location.href = "/"; }}
          >
            <p>{t('navbar.home')}</p>
          </div>

          <div className="lang-switch" role="group" aria-label="language">
            <button
              type="button"
              className={`lang-btn ${isFr ? 'active' : ''}`}
              onClick={() => changeLanguage('fr')}
              aria-pressed={isFr}
            >
              FR
            </button>
            <button
              type="button"
              className={`lang-btn ${isAr ? 'active' : ''}`}
              onClick={() => changeLanguage('ar')}
              aria-pressed={isAr}
            >
              AR
            </button>
          </div>
        </div>
      </div>

      <div className="logo">
        <img src={logo} alt="logo" />
      </div>

      {/* Mobile top bar: logo + burger button */}
      <div className="nv-mobile-bar">
        <img className="nv-mobile-logo" src={logo} alt="Protour" />
        <button
          type="button"
          className={`nv-burger ${menuOpen ? "is-open" : ""}`}
          onClick={updateMenu}
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          aria-expanded={menuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {/* Mobile slide-down panel */}
      {menuOpen && <div className="nv-backdrop" onClick={closeMenu} />}
      <nav className={`nv-drawer ${menuOpen ? "is-open" : ""}`}>
        <div className="nv-drawer__list">
          <button className="nv-drawer__item" onClick={() => { closeMenu(); window.location.href = "/"; }}>
            <FaHome /> <span>{t('navbar.home')}</span>
          </button>
          <button className="nv-drawer__item" onClick={() => { closeMenu(); window.location.href = "/visit-algeria"; }}>
            <FaMapMarkedAlt /> <span>🇩🇿 {t('navbar.visit_algeria')}</span>
          </button>
          <button className="nv-drawer__item" onClick={() => { closeMenu(); window.location.href = "/voyage"; }}>
            <FaPlaneDeparture /> <span>{t('navbar.organizedTrip')}</span>
          </button>
          <button className="nv-drawer__item" onClick={() => { closeMenu(); window.location.href = "/hotels"; }}>
            <FaHotel /> <span>{t('navbar.hotels')}</span>
          </button>
          <button className="nv-drawer__item" onClick={() => { closeMenu(); window.location.href = "/visa"; }}>
            <FaPassport /> <span>{t('navbar.visa')}</span>
          </button>

          <div className="nv-drawer__divider" />

          {isLoggedIn ? (
            <>
              <button className="nv-drawer__item" onClick={() => { closeMenu(); navigate("/profile"); }}>
                <FaUser /> <span>{t('navbar.profile')}</span>
              </button>
              <button className="nv-drawer__item" onClick={() => { closeMenu(); navigate("/profile?tab=3"); }}>
                <FaTicketAlt /> <span>{t('navbar.my_tickets')}</span>
              </button>
              <button className="nv-drawer__item" onClick={() => { closeMenu(); navigate("/profile?tab=4"); }}>
                <FaHeadset /> <span>{t('navbar.help_support')}</span>
              </button>
              <button className="nv-drawer__item nv-drawer__item--danger" onClick={() => { closeMenu(); handleLogout(); }}>
                <FaSignOutAlt /> <span>{t('navbar.logoutMobile')}</span>
              </button>
            </>
          ) : (
            <button className="nv-drawer__item nv-drawer__item--cta" onClick={() => { closeMenu(); window.location.href = "/login"; }}>
              <FaSignInAlt /> <span>{t('navbar.loginMobile')}</span>
            </button>
          )}

          <div className="nv-drawer__divider" />

          <div className="nv-drawer__lang" role="group" aria-label="language">
            <button type="button" className={`lang-btn ${isFr ? 'active' : ''}`} onClick={() => changeLanguage('fr')} aria-pressed={isFr}>FR</button>
            <button type="button" className={`lang-btn ${isAr ? 'active' : ''}`} onClick={() => changeLanguage('ar')} aria-pressed={isAr}>AR</button>
          </div>
        </div>
      </nav>
    </div>
  );
}